/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SigninImport } from './routes/sign_in'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSustainabilityactionsIndexImport } from './routes/_authenticated/sustainability_actions/index'
import { Route as AuthenticatedSettingsIndexImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedRegistrationsIndexImport } from './routes/_authenticated/registrations/index'
import { Route as AuthenticatedPremisesIndexImport } from './routes/_authenticated/premises/index'
import { Route as AuthenticatedPagesIndexImport } from './routes/_authenticated/pages/index'
import { Route as AuthenticatedInstallersIndexImport } from './routes/_authenticated/installers/index'
import { Route as AuthenticatedGrantsIndexImport } from './routes/_authenticated/grants/index'
import { Route as AuthenticatedContentblocksIndexImport } from './routes/_authenticated/content_blocks/index'
import { Route as AuthenticatedCollectivepurchasesIndexImport } from './routes/_authenticated/collective_purchases/index'
import { Route as AuthenticatedAudiencesIndexImport } from './routes/_authenticated/audiences/index'
import { Route as AuthenticatedArticlesIndexImport } from './routes/_authenticated/articles/index'
import { Route as AuthenticatedSustainabilityactionsNewImport } from './routes/_authenticated/sustainability_actions/new'
import { Route as AuthenticatedSustainabilityactioncategoriesNewImport } from './routes/_authenticated/sustainability_action_categories/new'
import { Route as AuthenticatedRegistrationsRegistrationIdImport } from './routes/_authenticated/registrations/$registrationId'
import { Route as AuthenticatedPremisesPremiseIdImport } from './routes/_authenticated/premises/$premiseId'
import { Route as AuthenticatedPagesNewImport } from './routes/_authenticated/pages/new'
import { Route as AuthenticatedInstallersNewImport } from './routes/_authenticated/installers/new'
import { Route as AuthenticatedGrantsNewImport } from './routes/_authenticated/grants/new'
import { Route as AuthenticatedCollectivepurchasesNewImport } from './routes/_authenticated/collective_purchases/new'
import { Route as AuthenticatedArticlesNewImport } from './routes/_authenticated/articles/new'
import { Route as AuthenticatedSustainabilityactionsSustainabilityActionIdEditImport } from './routes/_authenticated/sustainability_actions/$sustainabilityActionId.edit'
import { Route as AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditImport } from './routes/_authenticated/sustainability_action_categories/$sustainabilityActionCategoryId.edit'
import { Route as AuthenticatedPagesPageIdEditImport } from './routes/_authenticated/pages/$pageId.edit'
import { Route as AuthenticatedInstallersInstallerIdEditImport } from './routes/_authenticated/installers/$installerId.edit'
import { Route as AuthenticatedGrantsGrantIdEditImport } from './routes/_authenticated/grants/$grantId.edit'
import { Route as AuthenticatedContentblocksContentBlockIdEditImport } from './routes/_authenticated/content_blocks/$contentBlockId.edit'
import { Route as AuthenticatedCollectivepurchasesCollectivePurchaseIdEditImport } from './routes/_authenticated/collective_purchases/$collectivePurchaseId.edit'
import { Route as AuthenticatedAudiencesAudienceIdEditImport } from './routes/_authenticated/audiences/$audienceId.edit'
import { Route as AuthenticatedArticlesArticleIdEditImport } from './routes/_authenticated/articles/$articleId.edit'

// Create/Update Routes

const SigninRoute = SigninImport.update({
  path: '/sign_in',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedSustainabilityactionsIndexRoute =
  AuthenticatedSustainabilityactionsIndexImport.update({
    path: '/sustainability_actions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexImport.update(
  {
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedRegistrationsIndexRoute =
  AuthenticatedRegistrationsIndexImport.update({
    path: '/registrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPremisesIndexRoute = AuthenticatedPremisesIndexImport.update(
  {
    path: '/premises/',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedPagesIndexRoute = AuthenticatedPagesIndexImport.update({
  path: '/pages/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedInstallersIndexRoute =
  AuthenticatedInstallersIndexImport.update({
    path: '/installers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedGrantsIndexRoute = AuthenticatedGrantsIndexImport.update({
  path: '/grants/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedContentblocksIndexRoute =
  AuthenticatedContentblocksIndexImport.update({
    path: '/content_blocks/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedCollectivepurchasesIndexRoute =
  AuthenticatedCollectivepurchasesIndexImport.update({
    path: '/collective_purchases/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedAudiencesIndexRoute =
  AuthenticatedAudiencesIndexImport.update({
    path: '/audiences/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedArticlesIndexRoute = AuthenticatedArticlesIndexImport.update(
  {
    path: '/articles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedSustainabilityactionsNewRoute =
  AuthenticatedSustainabilityactionsNewImport.update({
    path: '/sustainability_actions/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSustainabilityactioncategoriesNewRoute =
  AuthenticatedSustainabilityactioncategoriesNewImport.update({
    path: '/sustainability_action_categories/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedRegistrationsRegistrationIdRoute =
  AuthenticatedRegistrationsRegistrationIdImport.update({
    path: '/registrations/$registrationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPremisesPremiseIdRoute =
  AuthenticatedPremisesPremiseIdImport.update({
    path: '/premises/$premiseId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPagesNewRoute = AuthenticatedPagesNewImport.update({
  path: '/pages/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedInstallersNewRoute = AuthenticatedInstallersNewImport.update(
  {
    path: '/installers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedGrantsNewRoute = AuthenticatedGrantsNewImport.update({
  path: '/grants/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedCollectivepurchasesNewRoute =
  AuthenticatedCollectivepurchasesNewImport.update({
    path: '/collective_purchases/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedArticlesNewRoute = AuthenticatedArticlesNewImport.update({
  path: '/articles/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedSustainabilityactionsSustainabilityActionIdEditRoute =
  AuthenticatedSustainabilityactionsSustainabilityActionIdEditImport.update({
    path: '/sustainability_actions/$sustainabilityActionId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditRoute =
  AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditImport.update(
    {
      path: '/sustainability_action_categories/$sustainabilityActionCategoryId/edit',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )

const AuthenticatedPagesPageIdEditRoute =
  AuthenticatedPagesPageIdEditImport.update({
    path: '/pages/$pageId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedInstallersInstallerIdEditRoute =
  AuthenticatedInstallersInstallerIdEditImport.update({
    path: '/installers/$installerId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedGrantsGrantIdEditRoute =
  AuthenticatedGrantsGrantIdEditImport.update({
    path: '/grants/$grantId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedContentblocksContentBlockIdEditRoute =
  AuthenticatedContentblocksContentBlockIdEditImport.update({
    path: '/content_blocks/$contentBlockId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedCollectivepurchasesCollectivePurchaseIdEditRoute =
  AuthenticatedCollectivepurchasesCollectivePurchaseIdEditImport.update({
    path: '/collective_purchases/$collectivePurchaseId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedAudiencesAudienceIdEditRoute =
  AuthenticatedAudiencesAudienceIdEditImport.update({
    path: '/audiences/$audienceId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedArticlesArticleIdEditRoute =
  AuthenticatedArticlesArticleIdEditImport.update({
    path: '/articles/$articleId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/sign_in': {
      id: '/sign_in'
      path: '/sign_in'
      fullPath: '/sign_in'
      preLoaderRoute: typeof SigninImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/articles/new': {
      id: '/_authenticated/articles/new'
      path: '/articles/new'
      fullPath: '/articles/new'
      preLoaderRoute: typeof AuthenticatedArticlesNewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/collective_purchases/new': {
      id: '/_authenticated/collective_purchases/new'
      path: '/collective_purchases/new'
      fullPath: '/collective_purchases/new'
      preLoaderRoute: typeof AuthenticatedCollectivepurchasesNewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/grants/new': {
      id: '/_authenticated/grants/new'
      path: '/grants/new'
      fullPath: '/grants/new'
      preLoaderRoute: typeof AuthenticatedGrantsNewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/installers/new': {
      id: '/_authenticated/installers/new'
      path: '/installers/new'
      fullPath: '/installers/new'
      preLoaderRoute: typeof AuthenticatedInstallersNewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/pages/new': {
      id: '/_authenticated/pages/new'
      path: '/pages/new'
      fullPath: '/pages/new'
      preLoaderRoute: typeof AuthenticatedPagesNewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/premises/$premiseId': {
      id: '/_authenticated/premises/$premiseId'
      path: '/premises/$premiseId'
      fullPath: '/premises/$premiseId'
      preLoaderRoute: typeof AuthenticatedPremisesPremiseIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/registrations/$registrationId': {
      id: '/_authenticated/registrations/$registrationId'
      path: '/registrations/$registrationId'
      fullPath: '/registrations/$registrationId'
      preLoaderRoute: typeof AuthenticatedRegistrationsRegistrationIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/sustainability_action_categories/new': {
      id: '/_authenticated/sustainability_action_categories/new'
      path: '/sustainability_action_categories/new'
      fullPath: '/sustainability_action_categories/new'
      preLoaderRoute: typeof AuthenticatedSustainabilityactioncategoriesNewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/sustainability_actions/new': {
      id: '/_authenticated/sustainability_actions/new'
      path: '/sustainability_actions/new'
      fullPath: '/sustainability_actions/new'
      preLoaderRoute: typeof AuthenticatedSustainabilityactionsNewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/articles/': {
      id: '/_authenticated/articles/'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof AuthenticatedArticlesIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/audiences/': {
      id: '/_authenticated/audiences/'
      path: '/audiences'
      fullPath: '/audiences'
      preLoaderRoute: typeof AuthenticatedAudiencesIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/collective_purchases/': {
      id: '/_authenticated/collective_purchases/'
      path: '/collective_purchases'
      fullPath: '/collective_purchases'
      preLoaderRoute: typeof AuthenticatedCollectivepurchasesIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/content_blocks/': {
      id: '/_authenticated/content_blocks/'
      path: '/content_blocks'
      fullPath: '/content_blocks'
      preLoaderRoute: typeof AuthenticatedContentblocksIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/grants/': {
      id: '/_authenticated/grants/'
      path: '/grants'
      fullPath: '/grants'
      preLoaderRoute: typeof AuthenticatedGrantsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/installers/': {
      id: '/_authenticated/installers/'
      path: '/installers'
      fullPath: '/installers'
      preLoaderRoute: typeof AuthenticatedInstallersIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/pages/': {
      id: '/_authenticated/pages/'
      path: '/pages'
      fullPath: '/pages'
      preLoaderRoute: typeof AuthenticatedPagesIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/premises/': {
      id: '/_authenticated/premises/'
      path: '/premises'
      fullPath: '/premises'
      preLoaderRoute: typeof AuthenticatedPremisesIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/registrations/': {
      id: '/_authenticated/registrations/'
      path: '/registrations'
      fullPath: '/registrations'
      preLoaderRoute: typeof AuthenticatedRegistrationsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/sustainability_actions/': {
      id: '/_authenticated/sustainability_actions/'
      path: '/sustainability_actions'
      fullPath: '/sustainability_actions'
      preLoaderRoute: typeof AuthenticatedSustainabilityactionsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/articles/$articleId/edit': {
      id: '/_authenticated/articles/$articleId/edit'
      path: '/articles/$articleId/edit'
      fullPath: '/articles/$articleId/edit'
      preLoaderRoute: typeof AuthenticatedArticlesArticleIdEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/audiences/$audienceId/edit': {
      id: '/_authenticated/audiences/$audienceId/edit'
      path: '/audiences/$audienceId/edit'
      fullPath: '/audiences/$audienceId/edit'
      preLoaderRoute: typeof AuthenticatedAudiencesAudienceIdEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/collective_purchases/$collectivePurchaseId/edit': {
      id: '/_authenticated/collective_purchases/$collectivePurchaseId/edit'
      path: '/collective_purchases/$collectivePurchaseId/edit'
      fullPath: '/collective_purchases/$collectivePurchaseId/edit'
      preLoaderRoute: typeof AuthenticatedCollectivepurchasesCollectivePurchaseIdEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/content_blocks/$contentBlockId/edit': {
      id: '/_authenticated/content_blocks/$contentBlockId/edit'
      path: '/content_blocks/$contentBlockId/edit'
      fullPath: '/content_blocks/$contentBlockId/edit'
      preLoaderRoute: typeof AuthenticatedContentblocksContentBlockIdEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/grants/$grantId/edit': {
      id: '/_authenticated/grants/$grantId/edit'
      path: '/grants/$grantId/edit'
      fullPath: '/grants/$grantId/edit'
      preLoaderRoute: typeof AuthenticatedGrantsGrantIdEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/installers/$installerId/edit': {
      id: '/_authenticated/installers/$installerId/edit'
      path: '/installers/$installerId/edit'
      fullPath: '/installers/$installerId/edit'
      preLoaderRoute: typeof AuthenticatedInstallersInstallerIdEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/pages/$pageId/edit': {
      id: '/_authenticated/pages/$pageId/edit'
      path: '/pages/$pageId/edit'
      fullPath: '/pages/$pageId/edit'
      preLoaderRoute: typeof AuthenticatedPagesPageIdEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/sustainability_action_categories/$sustainabilityActionCategoryId/edit': {
      id: '/_authenticated/sustainability_action_categories/$sustainabilityActionCategoryId/edit'
      path: '/sustainability_action_categories/$sustainabilityActionCategoryId/edit'
      fullPath: '/sustainability_action_categories/$sustainabilityActionCategoryId/edit'
      preLoaderRoute: typeof AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/sustainability_actions/$sustainabilityActionId/edit': {
      id: '/_authenticated/sustainability_actions/$sustainabilityActionId/edit'
      path: '/sustainability_actions/$sustainabilityActionId/edit'
      fullPath: '/sustainability_actions/$sustainabilityActionId/edit'
      preLoaderRoute: typeof AuthenticatedSustainabilityactionsSustainabilityActionIdEditImport
      parentRoute: typeof AuthenticatedImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedArticlesNewRoute: typeof AuthenticatedArticlesNewRoute
  AuthenticatedCollectivepurchasesNewRoute: typeof AuthenticatedCollectivepurchasesNewRoute
  AuthenticatedGrantsNewRoute: typeof AuthenticatedGrantsNewRoute
  AuthenticatedInstallersNewRoute: typeof AuthenticatedInstallersNewRoute
  AuthenticatedPagesNewRoute: typeof AuthenticatedPagesNewRoute
  AuthenticatedPremisesPremiseIdRoute: typeof AuthenticatedPremisesPremiseIdRoute
  AuthenticatedRegistrationsRegistrationIdRoute: typeof AuthenticatedRegistrationsRegistrationIdRoute
  AuthenticatedSustainabilityactioncategoriesNewRoute: typeof AuthenticatedSustainabilityactioncategoriesNewRoute
  AuthenticatedSustainabilityactionsNewRoute: typeof AuthenticatedSustainabilityactionsNewRoute
  AuthenticatedArticlesIndexRoute: typeof AuthenticatedArticlesIndexRoute
  AuthenticatedAudiencesIndexRoute: typeof AuthenticatedAudiencesIndexRoute
  AuthenticatedCollectivepurchasesIndexRoute: typeof AuthenticatedCollectivepurchasesIndexRoute
  AuthenticatedContentblocksIndexRoute: typeof AuthenticatedContentblocksIndexRoute
  AuthenticatedGrantsIndexRoute: typeof AuthenticatedGrantsIndexRoute
  AuthenticatedInstallersIndexRoute: typeof AuthenticatedInstallersIndexRoute
  AuthenticatedPagesIndexRoute: typeof AuthenticatedPagesIndexRoute
  AuthenticatedPremisesIndexRoute: typeof AuthenticatedPremisesIndexRoute
  AuthenticatedRegistrationsIndexRoute: typeof AuthenticatedRegistrationsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSustainabilityactionsIndexRoute: typeof AuthenticatedSustainabilityactionsIndexRoute
  AuthenticatedArticlesArticleIdEditRoute: typeof AuthenticatedArticlesArticleIdEditRoute
  AuthenticatedAudiencesAudienceIdEditRoute: typeof AuthenticatedAudiencesAudienceIdEditRoute
  AuthenticatedCollectivepurchasesCollectivePurchaseIdEditRoute: typeof AuthenticatedCollectivepurchasesCollectivePurchaseIdEditRoute
  AuthenticatedContentblocksContentBlockIdEditRoute: typeof AuthenticatedContentblocksContentBlockIdEditRoute
  AuthenticatedGrantsGrantIdEditRoute: typeof AuthenticatedGrantsGrantIdEditRoute
  AuthenticatedInstallersInstallerIdEditRoute: typeof AuthenticatedInstallersInstallerIdEditRoute
  AuthenticatedPagesPageIdEditRoute: typeof AuthenticatedPagesPageIdEditRoute
  AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditRoute: typeof AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditRoute
  AuthenticatedSustainabilityactionsSustainabilityActionIdEditRoute: typeof AuthenticatedSustainabilityactionsSustainabilityActionIdEditRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedArticlesNewRoute: AuthenticatedArticlesNewRoute,
  AuthenticatedCollectivepurchasesNewRoute:
    AuthenticatedCollectivepurchasesNewRoute,
  AuthenticatedGrantsNewRoute: AuthenticatedGrantsNewRoute,
  AuthenticatedInstallersNewRoute: AuthenticatedInstallersNewRoute,
  AuthenticatedPagesNewRoute: AuthenticatedPagesNewRoute,
  AuthenticatedPremisesPremiseIdRoute: AuthenticatedPremisesPremiseIdRoute,
  AuthenticatedRegistrationsRegistrationIdRoute:
    AuthenticatedRegistrationsRegistrationIdRoute,
  AuthenticatedSustainabilityactioncategoriesNewRoute:
    AuthenticatedSustainabilityactioncategoriesNewRoute,
  AuthenticatedSustainabilityactionsNewRoute:
    AuthenticatedSustainabilityactionsNewRoute,
  AuthenticatedArticlesIndexRoute: AuthenticatedArticlesIndexRoute,
  AuthenticatedAudiencesIndexRoute: AuthenticatedAudiencesIndexRoute,
  AuthenticatedCollectivepurchasesIndexRoute:
    AuthenticatedCollectivepurchasesIndexRoute,
  AuthenticatedContentblocksIndexRoute: AuthenticatedContentblocksIndexRoute,
  AuthenticatedGrantsIndexRoute: AuthenticatedGrantsIndexRoute,
  AuthenticatedInstallersIndexRoute: AuthenticatedInstallersIndexRoute,
  AuthenticatedPagesIndexRoute: AuthenticatedPagesIndexRoute,
  AuthenticatedPremisesIndexRoute: AuthenticatedPremisesIndexRoute,
  AuthenticatedRegistrationsIndexRoute: AuthenticatedRegistrationsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSustainabilityactionsIndexRoute:
    AuthenticatedSustainabilityactionsIndexRoute,
  AuthenticatedArticlesArticleIdEditRoute:
    AuthenticatedArticlesArticleIdEditRoute,
  AuthenticatedAudiencesAudienceIdEditRoute:
    AuthenticatedAudiencesAudienceIdEditRoute,
  AuthenticatedCollectivepurchasesCollectivePurchaseIdEditRoute:
    AuthenticatedCollectivepurchasesCollectivePurchaseIdEditRoute,
  AuthenticatedContentblocksContentBlockIdEditRoute:
    AuthenticatedContentblocksContentBlockIdEditRoute,
  AuthenticatedGrantsGrantIdEditRoute: AuthenticatedGrantsGrantIdEditRoute,
  AuthenticatedInstallersInstallerIdEditRoute:
    AuthenticatedInstallersInstallerIdEditRoute,
  AuthenticatedPagesPageIdEditRoute: AuthenticatedPagesPageIdEditRoute,
  AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditRoute:
    AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditRoute,
  AuthenticatedSustainabilityactionsSustainabilityActionIdEditRoute:
    AuthenticatedSustainabilityactionsSustainabilityActionIdEditRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteWithChildren
  '/sign_in': typeof SigninRoute
  '/': typeof AuthenticatedIndexRoute
  '/articles/new': typeof AuthenticatedArticlesNewRoute
  '/collective_purchases/new': typeof AuthenticatedCollectivepurchasesNewRoute
  '/grants/new': typeof AuthenticatedGrantsNewRoute
  '/installers/new': typeof AuthenticatedInstallersNewRoute
  '/pages/new': typeof AuthenticatedPagesNewRoute
  '/premises/$premiseId': typeof AuthenticatedPremisesPremiseIdRoute
  '/registrations/$registrationId': typeof AuthenticatedRegistrationsRegistrationIdRoute
  '/sustainability_action_categories/new': typeof AuthenticatedSustainabilityactioncategoriesNewRoute
  '/sustainability_actions/new': typeof AuthenticatedSustainabilityactionsNewRoute
  '/articles': typeof AuthenticatedArticlesIndexRoute
  '/audiences': typeof AuthenticatedAudiencesIndexRoute
  '/collective_purchases': typeof AuthenticatedCollectivepurchasesIndexRoute
  '/content_blocks': typeof AuthenticatedContentblocksIndexRoute
  '/grants': typeof AuthenticatedGrantsIndexRoute
  '/installers': typeof AuthenticatedInstallersIndexRoute
  '/pages': typeof AuthenticatedPagesIndexRoute
  '/premises': typeof AuthenticatedPremisesIndexRoute
  '/registrations': typeof AuthenticatedRegistrationsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/sustainability_actions': typeof AuthenticatedSustainabilityactionsIndexRoute
  '/articles/$articleId/edit': typeof AuthenticatedArticlesArticleIdEditRoute
  '/audiences/$audienceId/edit': typeof AuthenticatedAudiencesAudienceIdEditRoute
  '/collective_purchases/$collectivePurchaseId/edit': typeof AuthenticatedCollectivepurchasesCollectivePurchaseIdEditRoute
  '/content_blocks/$contentBlockId/edit': typeof AuthenticatedContentblocksContentBlockIdEditRoute
  '/grants/$grantId/edit': typeof AuthenticatedGrantsGrantIdEditRoute
  '/installers/$installerId/edit': typeof AuthenticatedInstallersInstallerIdEditRoute
  '/pages/$pageId/edit': typeof AuthenticatedPagesPageIdEditRoute
  '/sustainability_action_categories/$sustainabilityActionCategoryId/edit': typeof AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditRoute
  '/sustainability_actions/$sustainabilityActionId/edit': typeof AuthenticatedSustainabilityactionsSustainabilityActionIdEditRoute
}

export interface FileRoutesByTo {
  '/sign_in': typeof SigninRoute
  '/': typeof AuthenticatedIndexRoute
  '/articles/new': typeof AuthenticatedArticlesNewRoute
  '/collective_purchases/new': typeof AuthenticatedCollectivepurchasesNewRoute
  '/grants/new': typeof AuthenticatedGrantsNewRoute
  '/installers/new': typeof AuthenticatedInstallersNewRoute
  '/pages/new': typeof AuthenticatedPagesNewRoute
  '/premises/$premiseId': typeof AuthenticatedPremisesPremiseIdRoute
  '/registrations/$registrationId': typeof AuthenticatedRegistrationsRegistrationIdRoute
  '/sustainability_action_categories/new': typeof AuthenticatedSustainabilityactioncategoriesNewRoute
  '/sustainability_actions/new': typeof AuthenticatedSustainabilityactionsNewRoute
  '/articles': typeof AuthenticatedArticlesIndexRoute
  '/audiences': typeof AuthenticatedAudiencesIndexRoute
  '/collective_purchases': typeof AuthenticatedCollectivepurchasesIndexRoute
  '/content_blocks': typeof AuthenticatedContentblocksIndexRoute
  '/grants': typeof AuthenticatedGrantsIndexRoute
  '/installers': typeof AuthenticatedInstallersIndexRoute
  '/pages': typeof AuthenticatedPagesIndexRoute
  '/premises': typeof AuthenticatedPremisesIndexRoute
  '/registrations': typeof AuthenticatedRegistrationsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/sustainability_actions': typeof AuthenticatedSustainabilityactionsIndexRoute
  '/articles/$articleId/edit': typeof AuthenticatedArticlesArticleIdEditRoute
  '/audiences/$audienceId/edit': typeof AuthenticatedAudiencesAudienceIdEditRoute
  '/collective_purchases/$collectivePurchaseId/edit': typeof AuthenticatedCollectivepurchasesCollectivePurchaseIdEditRoute
  '/content_blocks/$contentBlockId/edit': typeof AuthenticatedContentblocksContentBlockIdEditRoute
  '/grants/$grantId/edit': typeof AuthenticatedGrantsGrantIdEditRoute
  '/installers/$installerId/edit': typeof AuthenticatedInstallersInstallerIdEditRoute
  '/pages/$pageId/edit': typeof AuthenticatedPagesPageIdEditRoute
  '/sustainability_action_categories/$sustainabilityActionCategoryId/edit': typeof AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditRoute
  '/sustainability_actions/$sustainabilityActionId/edit': typeof AuthenticatedSustainabilityactionsSustainabilityActionIdEditRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/sign_in': typeof SigninRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/articles/new': typeof AuthenticatedArticlesNewRoute
  '/_authenticated/collective_purchases/new': typeof AuthenticatedCollectivepurchasesNewRoute
  '/_authenticated/grants/new': typeof AuthenticatedGrantsNewRoute
  '/_authenticated/installers/new': typeof AuthenticatedInstallersNewRoute
  '/_authenticated/pages/new': typeof AuthenticatedPagesNewRoute
  '/_authenticated/premises/$premiseId': typeof AuthenticatedPremisesPremiseIdRoute
  '/_authenticated/registrations/$registrationId': typeof AuthenticatedRegistrationsRegistrationIdRoute
  '/_authenticated/sustainability_action_categories/new': typeof AuthenticatedSustainabilityactioncategoriesNewRoute
  '/_authenticated/sustainability_actions/new': typeof AuthenticatedSustainabilityactionsNewRoute
  '/_authenticated/articles/': typeof AuthenticatedArticlesIndexRoute
  '/_authenticated/audiences/': typeof AuthenticatedAudiencesIndexRoute
  '/_authenticated/collective_purchases/': typeof AuthenticatedCollectivepurchasesIndexRoute
  '/_authenticated/content_blocks/': typeof AuthenticatedContentblocksIndexRoute
  '/_authenticated/grants/': typeof AuthenticatedGrantsIndexRoute
  '/_authenticated/installers/': typeof AuthenticatedInstallersIndexRoute
  '/_authenticated/pages/': typeof AuthenticatedPagesIndexRoute
  '/_authenticated/premises/': typeof AuthenticatedPremisesIndexRoute
  '/_authenticated/registrations/': typeof AuthenticatedRegistrationsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/sustainability_actions/': typeof AuthenticatedSustainabilityactionsIndexRoute
  '/_authenticated/articles/$articleId/edit': typeof AuthenticatedArticlesArticleIdEditRoute
  '/_authenticated/audiences/$audienceId/edit': typeof AuthenticatedAudiencesAudienceIdEditRoute
  '/_authenticated/collective_purchases/$collectivePurchaseId/edit': typeof AuthenticatedCollectivepurchasesCollectivePurchaseIdEditRoute
  '/_authenticated/content_blocks/$contentBlockId/edit': typeof AuthenticatedContentblocksContentBlockIdEditRoute
  '/_authenticated/grants/$grantId/edit': typeof AuthenticatedGrantsGrantIdEditRoute
  '/_authenticated/installers/$installerId/edit': typeof AuthenticatedInstallersInstallerIdEditRoute
  '/_authenticated/pages/$pageId/edit': typeof AuthenticatedPagesPageIdEditRoute
  '/_authenticated/sustainability_action_categories/$sustainabilityActionCategoryId/edit': typeof AuthenticatedSustainabilityactioncategoriesSustainabilityActionCategoryIdEditRoute
  '/_authenticated/sustainability_actions/$sustainabilityActionId/edit': typeof AuthenticatedSustainabilityactionsSustainabilityActionIdEditRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/sign_in'
    | '/'
    | '/articles/new'
    | '/collective_purchases/new'
    | '/grants/new'
    | '/installers/new'
    | '/pages/new'
    | '/premises/$premiseId'
    | '/registrations/$registrationId'
    | '/sustainability_action_categories/new'
    | '/sustainability_actions/new'
    | '/articles'
    | '/audiences'
    | '/collective_purchases'
    | '/content_blocks'
    | '/grants'
    | '/installers'
    | '/pages'
    | '/premises'
    | '/registrations'
    | '/settings'
    | '/sustainability_actions'
    | '/articles/$articleId/edit'
    | '/audiences/$audienceId/edit'
    | '/collective_purchases/$collectivePurchaseId/edit'
    | '/content_blocks/$contentBlockId/edit'
    | '/grants/$grantId/edit'
    | '/installers/$installerId/edit'
    | '/pages/$pageId/edit'
    | '/sustainability_action_categories/$sustainabilityActionCategoryId/edit'
    | '/sustainability_actions/$sustainabilityActionId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign_in'
    | '/'
    | '/articles/new'
    | '/collective_purchases/new'
    | '/grants/new'
    | '/installers/new'
    | '/pages/new'
    | '/premises/$premiseId'
    | '/registrations/$registrationId'
    | '/sustainability_action_categories/new'
    | '/sustainability_actions/new'
    | '/articles'
    | '/audiences'
    | '/collective_purchases'
    | '/content_blocks'
    | '/grants'
    | '/installers'
    | '/pages'
    | '/premises'
    | '/registrations'
    | '/settings'
    | '/sustainability_actions'
    | '/articles/$articleId/edit'
    | '/audiences/$audienceId/edit'
    | '/collective_purchases/$collectivePurchaseId/edit'
    | '/content_blocks/$contentBlockId/edit'
    | '/grants/$grantId/edit'
    | '/installers/$installerId/edit'
    | '/pages/$pageId/edit'
    | '/sustainability_action_categories/$sustainabilityActionCategoryId/edit'
    | '/sustainability_actions/$sustainabilityActionId/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/sign_in'
    | '/_authenticated/'
    | '/_authenticated/articles/new'
    | '/_authenticated/collective_purchases/new'
    | '/_authenticated/grants/new'
    | '/_authenticated/installers/new'
    | '/_authenticated/pages/new'
    | '/_authenticated/premises/$premiseId'
    | '/_authenticated/registrations/$registrationId'
    | '/_authenticated/sustainability_action_categories/new'
    | '/_authenticated/sustainability_actions/new'
    | '/_authenticated/articles/'
    | '/_authenticated/audiences/'
    | '/_authenticated/collective_purchases/'
    | '/_authenticated/content_blocks/'
    | '/_authenticated/grants/'
    | '/_authenticated/installers/'
    | '/_authenticated/pages/'
    | '/_authenticated/premises/'
    | '/_authenticated/registrations/'
    | '/_authenticated/settings/'
    | '/_authenticated/sustainability_actions/'
    | '/_authenticated/articles/$articleId/edit'
    | '/_authenticated/audiences/$audienceId/edit'
    | '/_authenticated/collective_purchases/$collectivePurchaseId/edit'
    | '/_authenticated/content_blocks/$contentBlockId/edit'
    | '/_authenticated/grants/$grantId/edit'
    | '/_authenticated/installers/$installerId/edit'
    | '/_authenticated/pages/$pageId/edit'
    | '/_authenticated/sustainability_action_categories/$sustainabilityActionCategoryId/edit'
    | '/_authenticated/sustainability_actions/$sustainabilityActionId/edit'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SigninRoute: typeof SigninRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SigninRoute: SigninRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/sign_in"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/",
        "/_authenticated/articles/new",
        "/_authenticated/collective_purchases/new",
        "/_authenticated/grants/new",
        "/_authenticated/installers/new",
        "/_authenticated/pages/new",
        "/_authenticated/premises/$premiseId",
        "/_authenticated/registrations/$registrationId",
        "/_authenticated/sustainability_action_categories/new",
        "/_authenticated/sustainability_actions/new",
        "/_authenticated/articles/",
        "/_authenticated/audiences/",
        "/_authenticated/collective_purchases/",
        "/_authenticated/content_blocks/",
        "/_authenticated/grants/",
        "/_authenticated/installers/",
        "/_authenticated/pages/",
        "/_authenticated/premises/",
        "/_authenticated/registrations/",
        "/_authenticated/settings/",
        "/_authenticated/sustainability_actions/",
        "/_authenticated/articles/$articleId/edit",
        "/_authenticated/audiences/$audienceId/edit",
        "/_authenticated/collective_purchases/$collectivePurchaseId/edit",
        "/_authenticated/content_blocks/$contentBlockId/edit",
        "/_authenticated/grants/$grantId/edit",
        "/_authenticated/installers/$installerId/edit",
        "/_authenticated/pages/$pageId/edit",
        "/_authenticated/sustainability_action_categories/$sustainabilityActionCategoryId/edit",
        "/_authenticated/sustainability_actions/$sustainabilityActionId/edit"
      ]
    },
    "/sign_in": {
      "filePath": "sign_in.tsx"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/articles/new": {
      "filePath": "_authenticated/articles/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/collective_purchases/new": {
      "filePath": "_authenticated/collective_purchases/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/grants/new": {
      "filePath": "_authenticated/grants/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/installers/new": {
      "filePath": "_authenticated/installers/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/pages/new": {
      "filePath": "_authenticated/pages/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/premises/$premiseId": {
      "filePath": "_authenticated/premises/$premiseId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/registrations/$registrationId": {
      "filePath": "_authenticated/registrations/$registrationId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/sustainability_action_categories/new": {
      "filePath": "_authenticated/sustainability_action_categories/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/sustainability_actions/new": {
      "filePath": "_authenticated/sustainability_actions/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/articles/": {
      "filePath": "_authenticated/articles/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/audiences/": {
      "filePath": "_authenticated/audiences/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/collective_purchases/": {
      "filePath": "_authenticated/collective_purchases/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/content_blocks/": {
      "filePath": "_authenticated/content_blocks/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/grants/": {
      "filePath": "_authenticated/grants/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/installers/": {
      "filePath": "_authenticated/installers/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/pages/": {
      "filePath": "_authenticated/pages/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/premises/": {
      "filePath": "_authenticated/premises/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/registrations/": {
      "filePath": "_authenticated/registrations/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/sustainability_actions/": {
      "filePath": "_authenticated/sustainability_actions/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/articles/$articleId/edit": {
      "filePath": "_authenticated/articles/$articleId.edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/audiences/$audienceId/edit": {
      "filePath": "_authenticated/audiences/$audienceId.edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/collective_purchases/$collectivePurchaseId/edit": {
      "filePath": "_authenticated/collective_purchases/$collectivePurchaseId.edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/content_blocks/$contentBlockId/edit": {
      "filePath": "_authenticated/content_blocks/$contentBlockId.edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/grants/$grantId/edit": {
      "filePath": "_authenticated/grants/$grantId.edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/installers/$installerId/edit": {
      "filePath": "_authenticated/installers/$installerId.edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/pages/$pageId/edit": {
      "filePath": "_authenticated/pages/$pageId.edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/sustainability_action_categories/$sustainabilityActionCategoryId/edit": {
      "filePath": "_authenticated/sustainability_action_categories/$sustainabilityActionCategoryId.edit.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/sustainability_actions/$sustainabilityActionId/edit": {
      "filePath": "_authenticated/sustainability_actions/$sustainabilityActionId.edit.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
